import styled from 'styled-components/macro';
import { StatusType } from './StatusBar';
import { ThemeProps } from "@gf-easy-8/grmnext-foundation";

export const StatusBarWrapper = styled.div`
  background-color: ${({ theme: { colours } }): string => colours.statusBar.backgroundColor};
  color: ${({ theme: { colours } }): string => colours.statusBar.textColor};
  height: 40px;
  display: flex;
`;

function getBackgroundColor(status: string, theme: ThemeProps): string {
  switch (status) {
    case StatusType.ERROR:
      return theme.colours.statusBar.errorBackground;
    case StatusType.HEALTHY:
      return theme.colours.statusBar.healthyBackground;
    case StatusType.WARNING:
      return theme.colours.statusBar.warningBackground;
    case StatusType.LOADING:
      return theme.colours.statusBar.healthyBackground;
    default:
      return theme.colours.statusBar.errorBackground;
  }
}

export const StatusColorBox = styled.div<{ status: string }>`
  background-color: ${({ status, theme }): string => getBackgroundColor(status, theme)};
  width: 64px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;

  svg {
    fill: ${({ theme: { colours } }): string => colours.statusBar.textColor};
    height: 22px;
  }
`;
export const StatusText = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
`;
